import { z } from 'zod'

export const EditOrganizationSchema = z.object({
  organizationName: z
    .string()
    .min(1, { message: 'Name is required' })
    .max(68, { message: 'Organization name must be less than 68 characters' }),
  salesforceAccount: z.string().optional(),
})

export type EditOrganizationSchema = z.infer<typeof EditOrganizationSchema>

export const defaultValues: EditOrganizationSchema = {
  organizationName: '',
}
